import * as React from 'react';
import DefaultSelect from './index';
const Select = (props) => {
    const { input, className, meta: { touched, error }, children = React.createElement("option", null), ...restProps } = props;
    return (React.createElement(DefaultSelect, { ...restProps, ...input, className: className, error: error && touched }, children));
};
export default Select;
